<template>
    <v-btn-toggle v-if="codes.length > 1" :value="value" mandatory dense color="primary" class="currency-toggle"
        @change="$emit('input', $event)">
        <v-btn v-for="code in codes" :key="code" small :value="code">{{ code }}</v-btn>
    </v-btn-toggle>
</template>
<script>
/**
 * Selector de moneda del Dashboard. Solo aparece si hay más de una: los importes de monedas distintas nunca se
 * suman (no hay tipo de cambio), así que cada widget muestra una moneda a la vez. `v-model` con el código.
 */
export default {
    name: 'CurrencyToggle',
    props: {
        codes: { type: Array, default: () => [] },
        value: { type: String, default: '' }
    }
};
</script>
<style scoped>
.currency-toggle {
    flex: 0 0 auto;
}
</style>
